import { vuexHandbook } from '@/store/composition/handbook'
import { ReferenceTurnApi } from '@/api/handbook/position/ReferenceTurn/ReferenceTurnApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: ReferenceTurnApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
